module.exports = __webpack_public_path__ + "img/bobeh_bobocoin.gm.bf95da7.png";